export enum NodeState {
	Valid = 'valid',
	Invalid = 'invalid',
	Warning = 'warning',
	Found = 'found',
}
